/**
 * UNDEFINED LABEL — Region-aware availability
 *
 * Reads per-location stock embedded in the page (via the `region-stock-data`
 * snippet), geolocates the visitor by IP, maps their country to one of the
 * two warehouses (Canadian / Tokyo), and disables the Add to Cart button
 * with a contextual message when the visitor's region has 0 stock for the
 * currently selected variant.
 *
 * IMPORTANT: This script can only DISABLE buttons, never enable them.
 * If Liquid disabled the button (total stock = 0, etc.), it stays disabled.
 *
 * Test by appending ?test_country=SG (or US, GB, JP, etc.) to any product URL.
 */
(function () {
  'use strict';

  var COUNTRY_TO_LOCATION = {
    // Canadian Location (handles North America)
    US: '112776577346',
    CA: '112776577346',
    // Tokyo Location (handles Asia / Europe / Australia/NZ)
    HK: '110340505922',
    SG: '110340505922',
    KR: '110340505922',
    TW: '110340505922',
    AU: '110340505922',
    NZ: '110340505922',
    BE: '110340505922',
    FR: '110340505922',
    DE: '110340505922',
    IT: '110340505922',
    NL: '110340505922',
    SE: '110340505922',
    GB: '110340505922',
    UK: '110340505922', // ISO is GB; alias for the URL test override
    PT: '110340505922', // Portugal — added to Europe zone
    MY: '110340505922',
  };

  var MESSAGES = {
    soldOutInRegion: 'Sold out in your region',
    notShipped: 'Not currently available in your region',
    checking: 'Checking availability…',
  };

  var GEO_CACHE_KEY = 'ul_country';
  var GEO_CACHE_AT_KEY = 'ul_country_at';
  var GEO_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

  function getOverrideCountry() {
    try {
      var params = new URLSearchParams(window.location.search);
      var override = params.get('test_country');
      return override ? override.toUpperCase() : null;
    } catch (e) { return null; }
  }

  function getCachedCountry() {
    try {
      var country = localStorage.getItem(GEO_CACHE_KEY);
      var at = parseInt(localStorage.getItem(GEO_CACHE_AT_KEY) || '0', 10);
      if (!country) return null;
      if (Date.now() - at > GEO_CACHE_TTL_MS) return null;
      return country.toUpperCase();
    } catch (e) { return null; }
  }

  function cacheCountry(country) {
    try {
      localStorage.setItem(GEO_CACHE_KEY, country);
      localStorage.setItem(GEO_CACHE_AT_KEY, String(Date.now()));
    } catch (e) {}
  }

  function fetchCountry() {
    var override = getOverrideCountry();
    if (override) return Promise.resolve(override);
    var cached = getCachedCountry();
    if (cached) return Promise.resolve(cached);
    return fetch('https://ipapi.co/json/', { headers: { Accept: 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error('Geo API ' + res.status); return res.json(); })
      .then(function (data) {
        var code = (data && data.country_code) ? String(data.country_code).toUpperCase() : null;
        if (code) cacheCountry(code);
        return code;
      })
      .catch(function (err) { console.warn('[RegionAvailability] Geolocation failed:', err); return null; });
  }

  function getStockDataForForm(formEl) {
    var container =
      formEl.closest('product-info') ||
      formEl.closest('.product') ||
      formEl.closest('section') ||
      document;
    var node = container.querySelector('script[type="application/json"][data-region-stock]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); }
    catch (e) { console.warn('[RegionAvailability] Could not parse stock JSON:', e); return null; }
  }

  function disableButton(btn, message) {
    if (!btn) return;
    if (!btn.dataset.regionLocked) { btn.dataset.regionLocked = 'true'; }
    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('aria-disabled', 'true');
    var label = btn.querySelector('span');
    if (label) label.textContent = message;
  }

  function evaluateForm(formEl, country, locationId) {
    var btn = formEl.querySelector('[type="submit"][name="add"]');
    if (!btn) return;
    if (btn.hasAttribute('disabled') && !btn.dataset.regionLocked) return;
    if (!locationId) { disableButton(btn, MESSAGES.notShipped); return; }
    var stockData = getStockDataForForm(formEl);
    if (!stockData) return;
    var variantInput = formEl.querySelector('input[name="id"]');
    var variantId = variantInput ? String(variantInput.value) : null;
    if (!variantId) return;
    var variantStock = stockData[variantId];
    if (!variantStock) return;
    var qty = parseInt(variantStock[locationId] || 0, 10);
    if (qty <= 0) { disableButton(btn, MESSAGES.soldOutInRegion); }
  }

  var resolvedCountry = null;
  var resolvedLocationId = null;
  var ready = false;

  function evaluateAllForms() {
    if (!ready) return;
    document.querySelectorAll('product-form').forEach(function (form) {
      evaluateForm(form, resolvedCountry, resolvedLocationId);
    });
  }

  function init() {
    fetchCountry().then(function (country) {
      resolvedCountry = country;
      resolvedLocationId = country ? (COUNTRY_TO_LOCATION[country] || null) : null;
      ready = true;
      evaluateAllForms();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(evaluateAllForms, 0); }); }
      catch (e) {}
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') { setTimeout(evaluateAllForms, 0); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
